import addClasses from '../../../utils/addClasses';

export default function createToolTip() {
  const toolTip = document.createElement('div');
  addClasses(toolTip, [
    'tooltip--inline-edit',
    'tooltip--show',
  ]);

  const toolTipInner = document.createElement('div');
  toolTipInner.classList.add('tooltip-inner');
  toolTipInner.innerHTML = 'This cell must not be empty.';

  const toolTipArrow = document.createElement('div');
  toolTipArrow.classList.add('tooltip__arrow');

  toolTip.appendChild(toolTipInner);
  toolTip.appendChild(toolTipArrow);

  return toolTip;
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/createToolTip.js